export default __webpack_public_path__ + "static/in-browser-apps-preview-1-7ca8b067093e7bfa6cf61e3c29363a50.png";